<template>
	<div>
		<!-- <v-treeview v-model="areaArr" @input="areaInput" item-text="name" item-key="areaCode" selectable selection-type="independent" return-object item-disabled="locked" :items="AreaTree"></v-treeview> -->
		<v-menu offset-y :nudge-top="hideDetails ? '' : '24'">
			<template v-slot:activator="{ on, attrs }">
				<v-text-field v-model="itemText" :label="label" :rules="rules" :hide-details="hideDetails" readonly dense outlined v-bind="attrs" v-on="on"></v-text-field>
			</template>
			<v-sheet max-height="286" style="overflow: auto">
				<v-treeview
					v-model="areaArr"
					@input="areaInput"
					:activatable="!selectable"
					return-object
					transition
					dense
					hoverable
					item-key="areaCode"
					item-text="areaName"
					selection-type="independent"
					:items="AreaTree"
					:load-children="getTree"
					:active.sync="active"
					:selectable="selectable">
				</v-treeview>
			</v-sheet>
		</v-menu>
	</div>
</template>

<script>
const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export default {
	name: "VtkAreaTree",
	props: {
		value: {
			type: [String, Object, Array],
			default: null,
		},
		minArea: {
			type: Number,
			default: null,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		returnObject: {
			type: Boolean,
			default: false,
		},
		selectable: {
			type: Boolean,
			default: false,
		},
		rules: {
			type: Array,
			default: () => [],
		},
		label: {
			type: String,
			default: "请选择地区",
		},
		maxLeve: {
			type: Number,
			default: 0,
		},
		minLeve: {
			type: Number,
			default: 12,
		},
	},
	data() {
		return {
			user: {},
			entity: {},
			AreaTree: [
				{
					areaCode: "",
					areaName: "",
					children: [],
				},
			], //数据开放接口区域树形数据
			AreaList: [], //所有地区数据
			itemValue: "", //传值：最终选择值(地区编码)
			itemText: "", //最终选择值(中文)
			// 多选数组对象
			areaArr: [],
			// 单选数组对象
			active: [],
		};
	},
	watch: {
		// 单选项
		active() {
			this.$vtk.request.getForm(`dict/area/show/${this.active[0].areaCode}`).then((res) => {
				this.$emit("input", this.active[0].areaCode);
				this.itemText = [res.data.province, res.data.city, res.data.district, res.data.town, res.data.village].filter((item) => item).join("/");
			});
		},
	},
	created() {
		this.user = this.$vtk.storage.get("_wit_acis_users");
		this.getAreaName(this.user.uniAreaCode.slice(0, this.minLeve));
	},
	methods: {
		async getTree(item) {
			await pause(300);
			return this.$vtk.request.getForm(`dict/area/next/${item.areaCode}`).then((res) => {
				res.data.forEach((it) => {
					it.areaLeve < this.maxLeve && (it.children = []);
					item.children.push(it);
				});
			});
		},
		// 加载第一个地区，用户所在地区
		getAreaName(areacode) {
			this.AreaTree[0].areaCode = areacode;
			this.$vtk.request.getForm(`dict/area/show/${areacode}`).then((res) => {
				this.AreaTree[0].areaName = res.data.areaName;
				res.data.areaLeve < 12 && (this.AreaTree[0].children = []);
			});
		},

		// 确认选择
		areaInput() {
			this.areaArr.sort((a, b) => a.areaCode - b.areaCode);
			this.entity.areaName = [];
			this.entity.areaCode = [];
			this.areaArr.forEach((e) => {
				this.entity.areaName.push(e.areaName);
				this.entity.areaCode.push(e.areaCode);
			});
			if (this.selectable) {
				this.itemText = this.entity.areaName.join();
				this.$emit("input", this.entity.areaCode);
			}
			// this.$emit("input", this.entity.areaCode.join());
		},
	},
};
</script>

<style lang="scss" scoped>
.link::after {
	content: " / ";
	font-size: 14px;
	color: #999;
}
.link:last-of-type::after {
	content: "";
}
::v-deep .theme--dark.v-chip:not(.v-chip--active),
::v-deep .theme--light.v-chip:not(.v-chip--active) {
	background: #e0e0e000;
}
</style>
